import { HostBinding, Directive } from '@angular/core';

@Directive({
  selector: '[dateResponsiveUi]'
})
export class DateResponsiveUi {
  @HostBinding('class')
  elementClass = 'ant-col-xs-24 ant-col-sm-24 ant-col-md-24 ant-col-lg-24 ant-col-xl-16 ant-col-xxl-12';
}
